import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';

import { StorageService } from '../../../../../core/_services/storage.service';
import { currentUser, User } from '../../../../../core/auth';
import { AppState } from '../../../../../core/reducers';

@Component({
  selector: 'kt-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  // Public properties
  user$: Observable<User>;

  @Input() avatar = true;
  @Input() greeting = true;
  @Input() badge: boolean;
  @Input() icon: boolean;

  isLoggedAsUser = false;

  /**
   * Component constructor
   *
   * @param store: Store<AppState>
   */
  constructor(public router: Router, private store: Store<AppState>, private storage: StorageService) {
    this.isLoggedAsUser = storage.get('adminToken', false);
  }

  /**
   * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
   */

  /**
   * On init
   */
  ngOnInit(): void {
    this.user$ = this.store.pipe(
      select(currentUser),
      map((user) => plainToClass(User, user, { excludeExtraneousValues: true })),
    );
  }
}
